<template>
  <qx-empty-data
    :title="title"
    :description="$sanitize(description)" />
</template>

<script>
import { mapState } from 'vuex';
import QxEmptyData from '@/elements/QxEmptyData';

export default {
  name: 'EmptyList',
  components: {
    QxEmptyData,
  },
  data() {
    return {
      title: this.$gettext('The file(s) shared to you on this link are no longer available'),
    };
  },
  computed: {
    ...mapState({
      metadata: (state) => state.downloadPage.metadata,
    }),
    description() {
      return this.$gettextInterpolate(
        this.$gettext('Please contact %{ senderTag } for further details.'),
        { senderTag: `<a href="mailto:${this.metadata.sender.email}">${this.metadata.sender.name}</a>` },
        true
      );
    },
  },
};
</script>
